<header
  class="lfd-header clearfix"
  [attr.nav-layout]="navLayout"
  [attr.navbar-type]="toggleStatus ? defaultNavbar : toggleNavbar"
  [attr.effect-type]="navbarEffect"
  [attr.header-theme]="headerColorTheme"
  [attr.collapsed-left-header]="collapsedLeftHeader"
  [attr.device-type]="deviceType"
>
  <div class="lfd-header-wrapper clearfix">
    <div class="lfd-brand" [attr.left-header-theme]="leftHeaderColorTheme">
      <span class="lfd-brand-logo">
        <img src="assets/logo.png" style="width: 325px" />
      </span>
      <!-- <span class="lfd-brand-text">LFD Template</span> -->
    </div>
    <div class="lfd-header-navbar">
      <div class="lfd-left-header clearfix">
        <!-- <div class="sidebarToggle" (click)="changeTheToggleStatus()"><i class="fas fa-bars"></i></div> -->
        <!-- <div class="left-header-nav">
                    <ul>
                        <li><a href="" class="dropdown-toggle">Top Link 1</a></li>
                        <li><a href="" class="dropdown-toggle">Top Link 2</a></li>
                    </ul>
                </div> -->
      </div>

      <div class="lfd-right-header clearfix">
        <ul>
          <li>
            <a role="button" (click)="LogOut()"><span>Sign Out</span> </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</header>
